import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./admin.css";

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("role");
        if (!token || role !== "admin") {
            navigate("/login");
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("fullName");
        localStorage.removeItem("userId");
        localStorage.removeItem("isAdmin");
        navigate("/");
    };

    // 🔥 ACTIVE LINK STYLE
    const isActive = (path) => {
        if (path === "/admin/dashboard" && location.pathname === "/admin") {
            return "active";
        }
        return location.pathname === path ? "active" : "";
    };

    return ( 
        <div className="panel-layout">
            <div className="panel-mobile-topbar">
                <button
                    type="button"
                    className="panel-menu-btn"
                    onClick={() => setSidebarOpen((prev) => !prev)}
                    aria-label="Toggle admin menu"
                >
                    ☰
                </button>
                <span className="panel-mobile-title">Admin Panel</span>
            </div>

            {sidebarOpen && (
                <button
                    type="button"
                    className="panel-backdrop"
                    aria-label="Close sidebar"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* ================= SIDEBAR ================= */}
            <div
                className={`admin-sidebar panel-sidebar text-white p-3 d-flex flex-column ${sidebarOpen ? "open" : ""}`}
                style={{ minHeight: "100vh", position: "sticky", top: 0 }}
            >

                {/* LOGO */}
                <div className="text-center mb-4">
                    <img
                        src="/img/Logo.png"
                        alt="Logo"
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                            borderRadius: "10px",
                        }}
                    />
                    <h6 className="mt-2">Admin Panel</h6>
                </div>

                {/* NAVIGATION */}
                <Nav className="flex-column">

                    <Nav.Link
                        className={`text-white ${isActive("/admin/dashboard")}`}
                        onClick={() => {
                            navigate("/admin/dashboard");
                            setSidebarOpen(false);
                        }}
                    >
                        📊 Dashboard
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/add-news")}`}
                        onClick={() => {
                            navigate("/admin/add-news");
                            setSidebarOpen(false);
                        }}
                    >
                        📰 Add News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/manage-news")}`}
                        onClick={() => {
                            navigate("/admin/manage-news");
                            setSidebarOpen(false);
                        }}
                    >
                        🛠 Manage News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/epaper")}`}
                        onClick={() => {
                            navigate("/admin/epaper");
                            setSidebarOpen(false);
                        }}
                    >
                        📰 ePaper Manager
                    </Nav.Link>

                    {/* USERS (Guest Authors) */}
                    <Nav.Link
                        className={`text-white ${isActive("/admin/user")}`}
                        onClick={() => {
                            navigate("/admin/user");
                            setSidebarOpen(false);
                        }}
                    >
                        👤 User Management
                    </Nav.Link>

                </Nav>

                {/* LOGOUT BUTTON (BOTTOM) */}
                <div className="mt-auto">
                    <Nav.Link
                        className="logout-link"
                        onClick={() => {
                            setSidebarOpen(false);
                            handleLogout();
                        }}
                    >
                        🚪 Logout
                    </Nav.Link>
                </div>

            </div>

            {/* ================= MAIN CONTENT ================= */}
            <div className="flex-grow-1 panel-content p-4 bg-light">
                <Outlet />
            </div>

        </div>
    );
};

export default AdminLayout;